<template>
  <div>
    <h3 class="modal-title"> DISCUSSION </h3>

    <b-form-group :class="{'error-input' : $v.data_discussion.discussion.$error}">
      <label> Select Discussion </label>
      <j-single-select
        v-model="$v.data_discussion.discussion.$model"
        :options="list_discussion"
        :placeholder="`Choose Discussion`"
        label="name"
        value-format="object"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeDiscussion">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveDiscussion">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_discussion: {
      discussion: {
        required,
      },
    },
  },
  data() {
    return {
      data_discussion: {
        discussion: null,
      },
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_discussion']),

    generateDataDiscussion() {
      const infoName = this.data_discussion.discussion.name;
      const data = {
        info: JSON.stringify({
          id: this.data_discussion.discussion.id,
          name: infoName.toLowerCase().replace(/\s/g, '-'),
        }),
        value_id: `${this.data_discussion.discussion.id}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_discussion.discussion.name,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },

    generateDataDiscussionUpdate() {
      const infoName = this.data_discussion.discussion.name;
      const data = {
        info: JSON.stringify({
          id: this.data_discussion.discussion.id,
          name: infoName.toLowerCase().replace(/\s/g, '-'),
        }),
        value_id: `${this.data_discussion.discussion.id}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_discussion.discussion.name,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },
  },
  mounted() {
    this.getListDiscussion();

    if (this.modeEdit) {
      this.data_discussion.discussion = {
        id: JSON.parse(this.dataEdit.info).id,
        name: JSON.parse(this.dataEdit.info).name,
      };
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getListDiscussion']),

    saveDiscussion() {
      this.$v.data_discussion.$touch();
      if (!this.$v.data_discussion.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataDiscussion,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataDiscussionUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeDiscussion();
      }
    },

    closeDiscussion() {
      this.$emit('close-field');
      this.data_discussion.discussion = null;
      setTimeout(() => {
        this.$v.data_discussion.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jDiscussionSetup.vue